<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">รายการโปรโมชั่น</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12" v-if="storeDetail.status_main_store == 0">
          <div v-if="tab_id === 1" class="title_page ma-3">
            <v-btn type="button" class="btn_add_data" elevation="4" @click="link('/arin/pos/addpromotion')"
              large>จัดโปรโมชั่นแถมราคาถูกสุด</v-btn>
          </div>
          <div v-if="tab_id === 2" class="title_page ma-3">
            <v-btn type="button" class="btn_add_data" elevation="4" @click="link('/arin/pos/addpromotionnew')"
              large>จัดโปรโมชั่นราคาใหม่</v-btn>
          </div>
        </v-col>
      </v-row>
      <v-card elevation="4">
        <v-card-text>
          <v-row>
            <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
              <v-tabs color="#D6BFAF" v-if="$route.query.tab" slider-color="rgb(255, 255, 255)">
                <v-tab @click="tabs(1), $router.push({ query: { tab: '1' } })"
                  :style="$route.query.tab == '1' ? 'color:rgb(214, 191, 175);border-color: rgb(214, 191, 175) !important;' : 'color:rgba(0, 0, 0, 0.54);'">โปรโมชั่นแถมราคาถูกสุด</v-tab>
                <v-tab @click="tabs(2), $router.push({ query: { tab: '2' } })"
                  :style="$route.query.tab == '2' ? 'color:rgb(214, 191, 175);border-color: rgb(214, 191, 175) !important;' : 'color:rgba(0, 0, 0, 0.54);'">โปรโมชั่นราคาใหม่</v-tab>
              </v-tabs>
              <v-tabs color="#D6BFAF" v-else>
                <v-tab @click="tabs(1)">โปรโมชั่นแถมราคาถูกสุด</v-tab>
                <v-tab @click="tabs(2)">โปรโมชั่นราคาใหม่</v-tab>
              </v-tabs>
            </v-col>
            <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
              <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto" required
                v-model="search" placeholder="ค้นหา..." single-line outlined dense></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="mx-4"></v-divider>
          <div class="mt-3">
            <v-data-table :headers="tab_id == 1 ? headers : headersP" :items="data_list" :search="search"
              :footer-props="footer_Props" mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td class="hidden_line">
                    <div>{{ dataDetail.item.promotion_code }}</div>
                  </td>
                  <td class="hidden_line">
                    <div>{{ dataDetail.item.promotion_title }}</div>
                  </td>
                  <td class="hidden_line">
                    <div>{{ dataDetail.item.promotion_buy }}</div>
                  </td>
                  <td class="hidden_line">
                    <div v-if="tab_id == 1">{{ dataDetail.item.promotion_free }}</div>
                    <div v-if="tab_id == 2">{{ formatPrice(dataDetail.item.promotion_price) }}</div>
                  </td>
                  <td class="hidden_line">
                    <div :class="dataDetail.item.status == 0 ? 'error--text' : ''">{{ dataDetail.item.date_start_end }}
                    </div>
                  </td>
                  <td v-if="$store.state.store_arin.user_data.customer_type != 3" class="hidden_line">
                    <v-switch color="success" v-model="dataDetail.item.status"
                      @click="statusPromotion(dataDetail.item.id)" inset></v-switch>
                  </td>
                  <td class="hidden_line" v-if="storeDetail.status_main_store == 0">
                    <div class="pa-3">
                      <v-btn v-if="tab_id === 1" elevation="3" class="ma-2" outlined small height="45" color="#8EBBDC"
                        @click="link('/arin/pos/detailpromotion/' + dataDetail.item.id)"
                        style="border-radius: 10px;background-color: #FFFFFF" title="ดูรายละเอียด">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                      <v-btn v-if="tab_id === 2" elevation="3" class="ma-2" outlined small height="45" color="#8EBBDC"
                        @click="link('/arin/pos/detailpromotionnew/' + dataDetail.item.id)"
                        style="border-radius: 10px;background-color: #FFFFFF" title="ดูรายละเอียด">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                      <v-btn v-if="tab_id === 1" elevation="3" class="ma-2" outlined small height="45" color="#FEA06C"
                        @click="link('/arin/pos/editpromotion/' + dataDetail.item.id)"
                        style="border-radius: 10px;background-color: #FFFFFF" title="แก้ไขรายละเอียด">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn v-if="tab_id === 2" elevation="3" class="ma-2" outlined small height="45" color="#FEA06C"
                        @click="link('/arin/pos/editpromotionnew/' + dataDetail.item.id)"
                        style="border-radius: 10px;background-color: #FFFFFF" title="แก้ไขรายละเอียด">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn elevation="3" class="ma-2" outlined small height="45" color="#F28080"
                        @click="deletePromotion(dataDetail.item.id)" style="border-radius: 10px;background-color: #FFFFFF"
                        title="ลบข้อมูล">
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </div>
                  </td>
                  <td class="hidden_line" v-if="storeDetail.status_main_store == 1">
                    <div class="pa-3">
                      <v-btn v-if="tab_id === 1" elevation="3" class="ma-2" outlined small height="45" color="#8EBBDC"
                        @click="link('/arin/pos/detailpromotion/' + dataDetail.item.id)"
                        style="border-radius: 10px;background-color: #FFFFFF" title="ดูรายละเอียด">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                      <v-btn v-if="tab_id === 2" elevation="3" class="ma-2" outlined small height="45" color="#8EBBDC"
                        @click="link('/arin/pos/detailpromotionnew/' + dataDetail.item.id)"
                        style="border-radius: 10px;background-color: #FFFFFF" title="ดูรายละเอียด">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { formatPrice } from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_promotion_list",
  data() {
    return {
      loading_page: false,
      search: '',
      tab_id: 1,
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'คลังสินค้า',
          disabled: false,
        },
        {
          text: 'จัดโปรโมชั่นสินค้า',
          disabled: false,
          href: '#',
        },
      ],
      headers: this.$store.state.store_arin.user_data.customer_type != 3 ? [
        {
          text: 'รหัสโปรโมชั่น',
          value: 'promotion_code',
          fixed: true,
          width: '150px',
          align: 'left',
        },
        {
          text: 'ชื่อโปรโมชั่น',
          value: 'promotion_title',
          fixed: true,
          width: '250px',
        },
        {
          text: 'จำนวนซื้อ',
          value: 'promotion_buy',
          fixed: true,
          width: '140px',
        },
        {
          text: 'จำนวนแถม',
          value: 'promotion_free',
          fixed: true,
          width: '140px',
        },
        {
          text: 'วันที่เริ่มต้น - สิ้นสุดโปรโมชั่น',
          value: 'date_start_end',
          fixed: true,
          width: '200px',
        },
        {
          text: 'สถานะ',
          value: '',
          fixed: true,
          sortable: false,
          width: '120px',
        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          sortable: false,
          width: '200px',
        },
      ] :
        [
          {
            text: 'รหัสโปรโมชั่น',
            value: 'promotion_code',
            fixed: true,
            width: '150px',
            align: 'left',
          },
          {
            text: 'ชื่อโปรโมชั่น',
            value: 'promotion_title',
            fixed: true,
            width: '250px',
          },
          {
            text: 'จำนวนซื้อ',
            value: 'promotion_buy',
            fixed: true,
            width: '140px',
          },
          {
            text: 'จำนวนแถม',
            value: 'promotion_free',
            fixed: true,
            width: '140px',
          },
          {
            text: 'วันที่เริ่มต้น - สิ้นสุดโปรโมชั่น',
            value: 'date_start_end',
            fixed: true,
            width: '200px',
          },
          {
            text: 'จัดการ',
            value: '',
            fixed: true,
            sortable: false,
            width: '200px',
          },
        ]
      ,
      headersP: this.$store.state.store_arin.user_data.customer_type != 3 ? [
        {
          text: 'รหัสโปรโมชั่น',
          value: 'promotion_code',
          fixed: true,
          width: '150px',
          align: 'left',
        },
        {
          text: 'ชื่อโปรโมชั่น',
          value: 'promotion_title',
          fixed: true,
          width: '250px',
        },
        {
          text: 'จำนวนซื้อ',
          value: 'promotion_buy',
          fixed: true,
          width: '140px',
        },
        {
          text: 'ราคา',
          value: 'promotion_price',
          fixed: true,
          width: '140px',
        },
        {
          text: 'วันที่เริ่มต้น - สิ้นสุดโปรโมชั่น',
          value: 'date_start_end',
          fixed: true,
          width: '200px',
        },
        {
          text: 'สถานะ',
          value: '',
          fixed: true,
          sortable: false,
          width: '120px',
        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          sortable: false,
          width: '200px',
        },
      ] :
        [
          {
            text: 'รหัสโปรโมชั่น',
            value: 'promotion_code',
            fixed: true,
            width: '150px',
            align: 'left',
          },
          {
            text: 'ชื่อโปรโมชั่น',
            value: 'promotion_title',
            fixed: true,
            width: '250px',
          },
          {
            text: 'จำนวนซื้อ',
            value: 'promotion_buy',
            fixed: true,
            width: '140px',
          },
          {
            text: 'ราคา',
            value: 'promotion_price',
            fixed: true,
            width: '140px',
          },
          {
            text: 'วันที่เริ่มต้น - สิ้นสุดโปรโมชั่น',
            value: 'date_start_end',
            fixed: true,
            width: '200px',
          },
          {
            text: 'จัดการ',
            value: '',
            fixed: true,
            sortable: false,
            width: '200px',
          },
        ],
      data_list: [],
      storeDetail: null,
    }
  },
  methods: {
    link(link) {
      window.location.href = link;
      // window.location.href = link;
    },
    formatPrice(number) {
      return formatPrice(number);
    },
    getShow_api() {
      let store_id = this.$store.state.store_arin.user_data.store_id;
      // let emp_type = this.$store.state.store_arin.status_permission;
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/stores/detail/' + store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.storeDetail = res.data.storeDetail;
          this.loading_page = false;
        }
      })
    },
    tabs(number) {
      this.tab_id = parseInt(number)
      this.data_list = []
      let type_promotion = this.tab_id == 2 ? 1 : 0
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('promotion/promolist/' + type_promotion, config).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.promotionList;
          this.loading_page = false;
        }
      })
    },
    statusPromotion(id) {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.post('/promotion/updatestatus/' + id, null, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
        }
      })
    },
    deletePromotion(id) {
      Swal.fire({
        // title: 'คุณต้องการลบข้อมูลหรือไม่?',
        text: "คุณต้องการลบข้อมูลหรือไม่?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.isConfirmed) {
          const config = {
            headers: {
              'Content-Type': 'application/json',
              "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
            }
          };
          HTTP_ARIN.get('/promotion/deletepromo/' + id, config).then((res) => {
            if (res.data.successful === true) {
              let timerInterval
              Swal.fire({
                title: 'เสร็จสิ้น',
                text: 'ลบข้อมูลเรียบร้อยแล้ว',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  timerInterval = setInterval(() => { })
                },
                willClose: () => {
                  clearInterval(timerInterval)
                  setTimeout(function () {
                    window.location.reload();
                  });
                }
              })
            }
            else {
              Swal.fire({
                title: 'แจ้งเตือน',
                text: 'ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง!',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              });
            }
          })
        }
      })
    }
  },
  mounted() {
    this.getShow_api()
    if (this.$route.query.tab) {
      this.tabs(this.$route.query.tab)
    } else {
      this.tabs(1)
    }
  }
}
</script>

<style scoped>
.input-radius {
  border-radius: 10px;
}
</style>
